<template>
  <div>
    <div class="footer-link">
      <div class="link-switch">
        <span class="name">友情链接：</span>
        <span>
          <i
            class="el-icon-arrow-down"
            v-if="!showList"
            @click="switchType"
          ></i>
          <i class="el-icon-arrow-up" v-else @click="switchType"></i>
        </span>
      </div>
      <div class="link-list" v-if="showList">
        <div class="link-list-item">
          <img
            class="one-image"
            src="@/assets/images/gyhxxhb.png"
            @click="linkClick(1)"
            alt=""
          />
        </div>
        <div class="link-list-item">
          <img
            class="two-image"
            src="@/assets/images/link2.png"
            @click="linkClick(2)"
            alt=""
          />
        </div>

        <div class="link-list-item">
          <img
            class="three-image"
            src="@/assets/images/link3.png"
            @click="linkClick(3)"
            alt=""
          />
        </div>

        <div class="link-list-item">
          <img
            class="four-image"
            src="@/assets/images/link4.png"
            @click="linkClick(4)"
            alt=""
          />
        </div>

        <div class="link-list-item">
          <img
            class="five-image"
            src="@/assets/images/link5.png"
            @click="linkClick(5)"
            alt=""
          />
        </div>
      </div>
    </div>
    <div style="background-color: #333333">
      <div class="footer">
        <div class="footer-content">
          <img class="image" src="@/assets/images/footer-logo.png" alt="" />
          <div class="contact">
            <div class="left">
              <p class="title">联系方式</p>
              <p class="address">
                <img src="@/assets/images/addressIcon.png" alt="" />
                <span>地址：北京市海淀区复兴路65号电信实业大厦</span>
              </p>
              <div class="email">
                <p style="height: 100%">
                  <img src="@/assets/images/emailIcon.png" alt="" />
                  <span>邮箱： </span>
                </p>
                <p style="max-width: 80%">
                  数据存储专业委员会 datastorage@cesa-dsc.cn<br />
                  成员服务 members@cesa-dsc.cn
                </p>
              </div>
            </div>
            <div class="QRcode">
              <img src="../assets/images/wx.jpeg" alt="" />
              <div class="name">微信公众号</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-icp">
        <div class="footer-line"></div>
        <p class="name">中国电子工业标准化技术协会数据存储专业委员会</p>
        <p>
          <span>京ICP备06019433号-28</span>&nbsp;&nbsp;&nbsp;&nbsp;
          <span>京ICP备06019433号-29</span>
        </p>
        <p>
          <span>京ICP备06019433号-30</span>&nbsp;&nbsp;&nbsp;&nbsp;
          <span>京ICP备06019433号-31</span>
        </p>
        <p style="display: flex;align-items: center;justify-content: center;margin-top: 0.05rem;">
          <img style="height: 0.14rem;margin-right: 0.05rem;" src="@/assets/images/beian.png"><a style="color: rgba(255, 255, 255, 0.5);" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802046514" target="_blank">京公网安备11010802046514号</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showList: false,
    };
  },
  methods: {
    switchType() {
      this.showList = !this.showList;
    },
    linkClick(index) {
      if (index == 1) {
        window.open("https://wap.miit.gov.cn/");
      } else if (index == 2) {
        window.open("https://www.ndrc.gov.cn/");
      } else if (index == 3) {
        window.open("https://www.cac.gov.cn/");
      } else if (index == 4) {
        window.open("https://www.cesa.cn/");
      } else if (index == 5) {
        window.open("https://www.gccorg.com/");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.footer-link {
  width: 100vw;
  height: 0.44rem;
  background-color: #eef3ff;
  position: relative;
  .link-switch {
    width: 100%;
    height: 100%;
    background-color: #eef3ff;
    display: flex;
    padding: 0.15rem 0.24rem;
    justify-content: space-between;
    box-sizing: border-box;
    span {
      display: block;
      color: #000;
      font-size: 0.1rem;
      line-height: 0.14rem;
    }
  }
  .link-list {
    position: absolute;
    top: 0.44rem;
    width: 100%;
    background-color: #fff;
    .link-list-item {
      width: 100%;
      height: 0.3rem;
      padding: 0.05rem 0.24rem;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-bottom: 1px solid #e9e8e8;
    }
    img {
      cursor: pointer;
    }

    .one-image {
      width: 220px;
      height: 24.22px;
    }

    .two-image {
      width: 200px;
      height: 24.22px;
    }

    .three-image {
      width: 185.47px;
      height: 28.13px;
    }

    .four-image {
      width: 191.03px;
      height: 24.22px;
    }

    .five-image {
      width: 128px;
      height: 24.22px;
      margin-right: 0;
    }
  }
}

.footer {
  width: 100vw;
  background: #333333;
  padding: 0.17rem 0.24rem 0.06rem 0.24rem;
  box-sizing: border-box;

  .footer-content {
    width: 100%;
    margin: 0 auto;
    font-size: 16px;
    color: #fff;
    .image {
      width: 1.25rem;
      height: 0.24rem;
    }
    .contact {
      width: 100%;
      height: 0.82rem !important;
      margin-top: 0.1rem;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      .left {
        height: 100%;
        width: calc(100% - 0.06rem);
        display: flex;
        margin-top: -0.02rem;
        flex-direction: column;
        justify-content: space-between;
        p {
          margin: 0;
          line-height: 0.2rem;
        }
        .title {
          font-size: 0.14rem;
        }
        .address,
        .email {
          display: flex;
          align-items: center;
          font-size: 0.1rem;
          img {
            width: 0.12rem;
            height: 0.12rem;
            font-size: 0.1rem;
            margin-right: 0.089rem;
            vertical-align: middle;
          }
          span {
            line-height: 0.2rem;
            width: calc(100% - 0.12rem);
            vertical-align: middle;
          }
        }
      }
      .QRcode {
        width: 0.6rem !important;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        img {
          display: block;
          width: 0.55rem !important;
        }
        .name {
          font-size: 0.1rem;
          line-height: 0.2rem;
          text-align: center;
        }
      }
    }
  }
}

.footer-icp {
  width: 100vw;
  // height: 0.92rem;
  font-size: 0.1rem;
  background: #333333;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  padding: 0.17rem 0.24rem 0.24rem;
  box-sizing: border-box;
  .footer-line {
    width: 100% !important;
    height: 0.01rem;
    margin: -0.17rem 0 0.17rem;
    background-color: rgba(255, 255, 255, 0.5);
  }
  .name {
    margin-bottom: 0.1rem;
  }
  p {
    margin: 0 auto;
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.1rem;
    line-height: 0.14rem;
  }
}
</style>
